<template>
  <div
  v-bind:style="{
    'font-size': infoFontSize
  }"
  class="comp-psap-live-snapshot">

    <div class="info-container">

      <div class="info-items scrollable -x scrollbar-hidden">
        <div class="info-item black">LIVE VIDEO</div>
        <div
        v-if="liveSnapshotLocaleTimeString"
        class="info-item black">{{liveSnapshotLocaleTimeString}}</div>
      </div>

      <div
      v-if="statusGetPsapLiveSnapshot"
      v-bind:class="{
        success: statusGetPsapLiveSnapshot === 'successful',
        loading: statusGetPsapLiveSnapshot === 'requested',
        error: statusGetPsapLiveSnapshot === 'failed'
      }"
      class="status-container"></div>

    </div>

    <template v-if="options.isLiveEnabled">

      <comp-snapshot
      v-bind:snapshot="liveSnapshot ? liveSnapshot.data : null"
      v-bind:isOldSnapshot="isOldSnapshot">
      </comp-snapshot>

    </template>
    <template v-else>

      <div class="not-supported-container">
        <div class="not-supported-text">
          Live view is not supported on this camera.
        </div>
      </div>

    </template>

  </div>
</template>

<script>
import CompIcon from '@/components/CompIcon'
import CompSnapshot from '@/components/CompSnapshot'
export default {
  name: 'comp-psap-live-snapshot',
  components: {
    CompIcon,
    CompSnapshot
  },
  props: {
    infoFontSize: {
      type: String,
      default: function () {
        return '16px'
      }
    },
    autoPlay: {
      type: Boolean,
      default: function () {
        return true
      }
    },
    isStandAloneMode: {
      type: Boolean,
      default: function () {
        return true
      }
    }
  },
  computed: {
    psapSite: function () {
      return this.$store.getters.psapSite
    },
    liveSnapshot: function () {
      return this.$store.getters.psapLiveSnapshot
    },
    liveSnapshotUrl: function () {
      return this.$store.getters.psapLiveSnapshotUrl
    },
    statusGetPsapLiveSnapshot: function () {
      return this.$store.getters.statusGetPsapLiveSnapshot
    },
    statusGetPsapLiveSnapshotUrl: function () {
      return this.$store.getters.statusGetPsapLiveSnapshotUrl
    }
  },
  data: function () {
    return {
      isVisible: true,
      isOldSnapshot: false,
      isOnline: false,
      zoneList: [],
      options: {
        isLiveEnabled: true,
        isEventEnabled: true
      },
      checkingLiveSnapshotTimestamp$i: null,
      getLiveSnapshot$t: null,
      downloadSpeed: '300ms',
      liveSnapshotLocaleTimeString: null,
      lastLiveSnapshotRequestedTimestamp: 0,
      liveSnapshotRequestDelay: 1000 * 3,
      isFailSnapshotAPIV2: null,
      isFailSnapshotAPIV1: null
    }
  },
  watch: {
    isOnline: function () {
      this.init()
    },
    options: function () {
      this.init()
    },
    autoPlay: function (autoPlay) {
      if (autoPlay) {
        this.getLiveSnapshotV2()
      } else {
        this.stopRefreshLiveSnapshot()
      }
    },
    isStandAloneMode: function () {
      this.updateLiveSnapshotRequestDelay()
    },
    statusGetPsapLiveSnapshotUrl: function () {
      if (this.statusGetPsapLiveSnapshotUrl === 'successful') {
        this.getLiveSnapshotV2()
      }
    }
  },
  created: function () {
    this.init()
    this.startCheckingLiveSnapshotTimestamp()
  },
  beforeDestroy: function () {
    this.isVisible = false
    this.stopRefreshLiveSnapshot()
    this.stopCheckingLiveSnapshotTimestamp()
  },
  methods: {
    init: function () {
      this.stopRefreshLiveSnapshot()
      this.updateLiveSnapshotRequestDelay()
      // this.getLiveSnapshot()
      this.getLiveSnapshotUrl()
      this.updateLiveSnapshotTimeString()
    },
    startCheckingLiveSnapshotTimestamp: function () {
      this.stopCheckingLiveSnapshotTimestamp()
      this.checkingLiveSnapshotTimestamp$i = setInterval(() => {
        this.checkLiveSnapshotTimestamp()
        this.updateLiveSnapshotTimeString()
      }, 1000)
    },
    stopCheckingLiveSnapshotTimestamp: function () {
      if (this.checkingLiveSnapshotTimestamp$i) clearInterval(this.checkingLiveSnapshotTimestamp$i)
      this.checkingLiveSnapshotTimestamp$i = null
    },
    updateLiveSnapshotTimeString: function () {
      if (this.liveSnapshot && this.psapSite.timezone) {
        let timezoneOffset = this.$tool.getUtcOffset((this.psapSite.timezone))
        let timestamp = parseInt(this.liveSnapshot.timestamp)
        let liveSnapshotLocalTimestamp = this.$tool.getLocalTimestamp(timestamp, timezoneOffset)
        this.liveSnapshotLocaleTimeString = new Date(liveSnapshotLocalTimestamp).toLocaleTimeString()
      }
    },
    getLiveSnapshotUrl: function () {
      this.$store.dispatch('getPsapLiveSnapshotUrl')
    },
    getLiveSnapshot: function () {
      // this.statusMonitoringGetLiveSnapshot !== 'requested'
      // is to prevent multiple request of snapshot
      // this doesn't work..... maybe I need to change this to using interval instead of timeout
      if (this.autoPlay) {
        this.lastLiveSnapshotRequestedTimestamp = new Date().getTime()
        this.$store.dispatch('getPsapLiveSnapshot').then(
          res => {
            let currentTimestamp = new Date().getTime()
            let msecondDiff = currentTimestamp - this.lastLiveSnapshotRequestedTimestamp
            this.downloadSpeed = msecondDiff + 'ms'
            this.checkLiveSnapshotTimestamp()
            // this.updateLiveSnapshotTimeString()
            // make sure that when device id changed,, not doing this routine
            // it is because timeout works differently compared to interval
            // (it is to prevent multiple ongoing timeout)
            if (this.isVisible) {
              this.getLiveSnapshot$t = setTimeout(() => {
                this.getLiveSnapshot()
              }, this.liveSnapshotRequestDelay)
            }
          },
          err => {
            this.$logger.error(err['message'])
          }
        )
      } else {
        this.stopRefreshLiveSnapshot()
      }
    },
    getLiveSnapshotV2: function () {
      // this.statusMonitoringGetLiveSnapshot !== 'requested'
      // is to prevent multiple request of snapshot
      // this doesn't work..... maybe I need to change this to using interval instead of timeout
      const snapshotUrl = this.liveSnapshotUrl.url
      const token = this.liveSnapshotUrl.access_token
      if (this.autoPlay && snapshotUrl && token) {
        this.lastLiveSnapshotRequestedTimestamp = new Date().getTime()
        this.$store.dispatch('getPsapLiveSnapshotV2', {snapshotUrl, token}).then(
          res => {
            let currentTimestamp = new Date().getTime()
            let msecondDiff = currentTimestamp - this.lastLiveSnapshotRequestedTimestamp
            this.downloadSpeed = msecondDiff + 'ms'
            this.checkLiveSnapshotTimestamp()
            // this.updateLiveSnapshotTimeString()
            // make sure that when device id changed,, not doing this routine
            // it is because timeout works differently compared to interval
            // (it is to prevent multiple ongoing timeout)
            if (this.isVisible) {
              this.getLiveSnapshot$t = setTimeout(() => {
                this.getLiveSnapshotV2()
              }, this.liveSnapshotRequestDelay)
            }
          },
          err => {
            this.$logger.error(err['message'])
            this.isFailSnapshotAPIV2 = true
            this.stopRefreshLiveSnapshot()
            this.getLiveSnapshot()
          }
        )
      } else {
        this.stopRefreshLiveSnapshot()
      }
    },
    stopRefreshLiveSnapshot: function () {
      if (this.getLiveSnapshot$t) {
        clearTimeout(this.getLiveSnapshot$t)
        this.getLiveSnapshot$t = null
      }
    },
    checkLiveSnapshotTimestamp: function () {
      if (this.liveSnapshot) {
        let nowTimestamp = new Date().getTime()
        let secondDiff = +nowTimestamp - +this.liveSnapshot.timestamp
        this.isOldSnapshot = secondDiff > 1000 * 10
      }
    },
    updateLiveSnapshotRequestDelay: function () {
      if (this.isStandAloneMode) {
        this.liveSnapshotRequestDelay = 1000 * 1
      } else {
        this.liveSnapshotRequestDelay = 1000 * 4
      }
    }
  }
}
</script>

<style scoped>
.comp-psap-live-snapshot {
  /* common */
  background-color: #fff;
  color: #333;
  font-size: 14px;
  outline: 1px solid #fff;
  /* size */
  width: 100%;
  height: 100%;
  /* alignment */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}

.comp-psap-live-snapshot .not-supported-container {
  /* common */
  background-color: #333;
  /* position */
  position: relative;
  /* size */
  width: 100%;
  padding-top: calc(100% / 16 * 9);
}
.comp-psap-live-snapshot .not-supported-container .not-supported-text {
  /* common */
  font-size: 1.5em;
  background-color: #333;
  color: #fff;
  overflow: hidden;
  /* size */
  padding: 1em;
  width: calc(100% - 2em);
  height: calc(100% - 2em);
  /* position */
  position: absolute;
  top: 0;
  left: 0;
  /* alignment */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.comp-psap-live-snapshot .not-supported-container.has-snapshot {
  /* common */
  opacity: 0.5;
  /* position */
  position: absolute;
  bottom: 0;
  left: 0;
}

.comp-psap-live-snapshot .info-container {
  /* common */
  font-size: 0.8em;
  background-color: #000;
  color: #fff;
  /* size */
  width: 100%;
  height: 39.9px;
  /* position */
  position: relative;
  /* alignment */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.comp-psap-live-snapshot .info-container .info-items {
  /* size */
  padding: 0.5em 0.5em 0.5em 0.5em;
  width: calc(100% - 1em);
  /* alignment */
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.comp-psap-live-snapshot .info-container .info-items .info-item {
  /* common */
  background-color: hsla(202, 100%, 80%, 1);
  color: hsla(193, 100%, 0%, 0.7);
  border-radius: 1px;
  cursor: pointer;
  font-weight: bold;
  white-space: nowrap;
  /* size */
  padding: 2px 0.5em;
  /* position */
  position: relative;
  margin-right: 0.2em;
  /* alignment */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.comp-psap-live-snapshot .info-container .info-items .info-item:last-child {
  /* position */
  margin-right: 0;
}
.comp-psap-live-snapshot .info-container .info-items .info-item.black {
  /* common */
  color: #fff;
  background-color: #000;
}
.comp-psap-live-snapshot .info-container .info-items .info-item.info {
  /* common */
  color: #fff;
  background-color: hsla(202, 100%, 50%, 1);
}
.comp-psap-live-snapshot .info-container .info-items .info-item.error {
  /* common */
  color: #fff;
  background-color: hsla(0, 100%, 60%, 1);
}
.comp-psap-live-snapshot .info-container .info-items .info-item.inactive {
  /* common */
  background-color: hsla(202, 0%, 30%, 0.1);
  color: #fff;
}


.comp-psap-live-snapshot .info-container .device-name {
  /* text */
  white-space: nowrap;
  text-align: left;
  /* size */
  padding: 0.5em;
  width: calc(100% - 1em);
  height: calc(100% - 1em);
  /* alignment */
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.comp-psap-live-snapshot .info-container .status-container {
  /* common */
  background-color: hsla(202, 0%, 0%, 1);
  color: transparent;
  font-size: 12px;
  /* size */
  width: 100%;
  height: 6px;
  /* animation */
  transition: opacity .2s;
}
.comp-psap-live-snapshot .info-container .status-container.success {
  /* common */
  background-color: hsla(202, 100%, 50%, 1);
  opacity: 1;
}
.comp-psap-live-snapshot .info-container .status-container.loading {
  /* common */
  background-color: hsla(202, 100%, 50%, 1);
  opacity: 0.2;
}
.comp-psap-live-snapshot .info-container .status-container.error {
  /* common */
  background-color: hsla(0, 100%, 70%, 1);
}


.comp-psap-live-snapshot .sensors-location-wrapper {
  /* size */
  width: 100%;
  /* position */
  position: absolute;
  bottom: 0;
  left: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/CompPsapLiveSnapshot.vue